import { Study } from 'src/app/models/study';
import { Intervention } from 'src/app/models/intervention';
import { StudyType } from 'src/app/models/study-type';
import { environment } from 'src/environments/environment';
import { InterventionContentItem } from '../../../models/intervention-content-item';

export enum SELECT_LIST_ITEM_TYPE {
  MODULE = 'module',
  INFORMATIVE_PAGE = 'page',
}

export function getInterventionContentItemSortOrderArray(items: InterventionContentItem[]): InterventionContentItem[] {
  return items?.map((item) => ({
    type: item?.module ? SELECT_LIST_ITEM_TYPE.MODULE : SELECT_LIST_ITEM_TYPE.INFORMATIVE_PAGE,
    id: item.id,
  }));
}

export function addTransformedInterventions(study: Study): Intervention[] {
  const transformedInterventions: Intervention[] = [];

  study.interventions.forEach((intervention: Intervention) => {
    const url =
      study.type === StudyType.CC
        ? environment.careerUrl + '/' + intervention.hash + '/preview'
        : environment.appUrl + '/preview/' + study.hash + '/' + intervention.id;
    const transformedIntervention: Intervention = {
      ...intervention,
      url: { label: 'Preview URL', url },
    };
    transformedInterventions.push(transformedIntervention);
  });
  return transformedInterventions;
}

export function getInterventionContentItemId(
  item: InterventionContentItem,
  interventionContentItems: InterventionContentItem[]
): number {
  return interventionContentItems?.find((contentItem) => {
    return contentItem.module ? item.id === contentItem.module.id : item.id === contentItem.page.id;
  })?.id;
}

export function reorderInterventionContentItems(contentItemsSortingOrder, interventionContentItems) {
  const orderOfIds = contentItemsSortingOrder.map((orderItem) => orderItem.id);
  return interventionContentItems.sort(
    (contentItem1, contentItem2) => orderOfIds.indexOf(contentItem1.id) - orderOfIds.indexOf(contentItem2.id)
  );
}
